<!-- Idea Modal Header Start-->
<div class="modal-header">
  <h2 class="modal-title d-xs-none d-md-block">Search Picture</h2>
  <button
    type="button"
    (click)="onCancel()"
    class="btn-close"
    title="Close"></button>
</div>
<!-- Idea Modal Header End-->

<!-- Idea Modal Body Start-->
<div class="modal-body idea-modal clearfix">
  <div class="row content">
    <div class="col-lg-12 search-input">
      <input
        class="form-control"
        type="text"
        [(ngModel)]="searchText"
        placeholder="Search for Keyword"
        (keyup.enter)="search()" />
      <div
        class="btn btn-secondary fa fa-search"
        [ngClass]="{ disabled: searchInProgress }"
        (click)="search()"></div>
    </div>

    <div *ngIf="pixabay_images" class="search-result col-lg-12">
      <ng-container *ngIf="pixabay_images.length > 0">
        <div
          *ngFor="let image of pixabay_images"
          class="pixabay-image-container col-lg-3 chrome-no-repaint">
          <img
            class="pixabay-image"
            (click)="selectImage(image)"
            [ngClass]="{ selected: image === selectedImage }"
            [src]="image['url_sm']"
            alt="Could not be loaded" />
        </div>
      </ng-container>
      <ng-container *ngIf="pixabay_images.length === 0">
        <div class="not-found-label h3 text-center">No Images found</div>
      </ng-container>
    </div>
  </div>
</div>
<!-- Idea Modal Body End-->

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    [ngClass]="{ disabled: !selectedImage }"
    (click)="onConfirm()">
    Select
  </button>
  <button type="button" class="btn btn-secondary" (click)="onCancel()">
    Cancel
  </button>
</div>
